import React from 'react'
import Image from 'next/image'
import * as Types from '../../../declarations'
import { getUploadThumbPath } from '../../../lib/display'

interface Props {
	images: Types.DB.Models.UploadAttributes[]
	slug: string
	altText: string
	onImageClick: (imageId: number) => void
}

const MultiPicDesign = ({ images, altText, onImageClick }: Props) => {
	const src = getUploadThumbPath(images[0]?.id, 'large')
	// const src = `https://${process.env.NEXT_PUBLIC_CDN_BASE}.cdn.guidedpeaks.com/originals/${images[0]?.id}.jpg`

	// const cdnSrc = `https://www.guidedpeaks.com/cdn-cgi/image/format=auto,fit=cover,height=325,quality=100/${src}`

	return (
		<div id="multipic-design">
			<div className="column" id="big-pic">
				<Image
					src={src}
					// src={cdnSrc}
					onClick={() => onImageClick(images[0].id)}
					alt={altText}
					width={540}
					height={325}
					style={{
						width: '100%',
						height: '100%',
						objectFit: 'cover',
						objectPosition: 'center',
					}}
					priority={true}
				/>
			</div>
			<div className="column">
				<div id="twobytwo">
					{images.slice(1, 5).map((item, key) => {
						// const tile = getUploadThumbPath(item.id, 'large')
						// const tile = getUploadThumbPath(item.id, 'medium')
						const tile = getUploadThumbPath(item.id, 'medium')

						// const tile = `https://${process.env.NEXT_PUBLIC_CDN_BASE}.cdn.guidedpeaks.com/originals/${item.id}.jpg`

						// const cdnTile = `https://www.guidedpeaks.com/cdn-cgi/image/format=auto,width=250,height=160,quality=100,sharpen=0.5/${tile}`

						return (
							<div
								key={key}
								style={{
									...(key === 1 ? { borderTopRightRadius: 8 } : {}),
									...(key === 3 ? { borderBottomRightRadius: 8 } : {}),
								}}
							>
								<Image
									style={{
										width: '100%',
										height: '100%',
										objectFit: 'cover',
										objectPosition: 'center',
									}}
									width={250}
									height={160}
									src={tile}
									// src={cdnTile}
									alt={altText}
									onClick={() => onImageClick(item.id)}
								/>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	)
}

export default MultiPicDesign
